'use client';

import { useEffect } from 'react';
import { useTranslation } from '@/lib/i18n';
import { useHeader } from '@/contexts/HeaderContext';
import Link from 'next/link';
import { FolderHeart } from 'lucide-react';
import { usePathname } from 'next/navigation';

export interface PortfolioTrackRenderProps {
  /** 是否在 Header 右侧显示 Track wallet 入口；默认显示 */
  showLabel?: boolean;
}

export default function PortfolioTrackRender({ showLabel = false }: PortfolioTrackRenderProps) {
  const { setRightContent } = useHeader();

  useEffect(() => {
    setRightContent(<TrackWalletLink showLabel={showLabel} />);
  }, [setRightContent, showLabel]);

  return null;
}

function TrackWalletLink({ showLabel = false }: { showLabel?: boolean }) {
  const { t } = useTranslation();
  const pathname = usePathname();

  if (pathname !== '/predic/portfolio') {
    return null;
  }

  return (
    <Link
      href="/predic/portfolio/tracking"
      className="hover:text-[#A772FF] flex items-center gap-2 text-sm"
    >
      <FolderHeart size={20} />
      {showLabel ? t('Track wallet') : ''}
    </Link>
  );
}
